// src/components/common/DisclaimerFooter.js - Legal disclaimer dropdown (إخلاء مسؤولية)
import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const DisclaimerFooter = ({ className = '' }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    const handleClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target) && triggerRef.current && !triggerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('keydown', handleEscape);
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  return (
    <div className={`relative text-center ${className}`}>
      <button
        ref={triggerRef}
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-controls="disclaimer-panel"
        aria-haspopup="true"
        className="text-xs text-shayek-light-500 dark:text-shayek-dark-500 hover:text-shayek-primary dark:hover:text-shayek-red-light underline focus:outline-none focus:ring-2 focus:ring-shayek-primary focus:ring-offset-1 rounded px-1"
      >
        {t('common.disclaimer.title', 'Disclaimer')} (إخلاء مسؤولية)
      </button>
      {open && (
        <div
          id="disclaimer-panel"
          ref={panelRef}
          role="region"
          aria-label={t('common.disclaimer.title', 'Disclaimer')}
          className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-[min(90vw,28rem)] max-h-[70vh] overflow-y-auto rounded-lg border-2 border-shayek-light-300 dark:border-shayek-dark-200 bg-white dark:bg-shayek-dark-100 shadow-shayek-lg p-4 text-start z-50"
        >
          <h3 className="text-sm font-semibold text-shayek-light-900 dark:text-shayek-dark-900 mb-3">
            {t('common.disclaimer.title', 'Disclaimer')}
          </h3>
          <p className="text-xs text-shayek-light-700 dark:text-shayek-dark-300 mb-3 leading-relaxed">
            {t('common.disclaimer.intro')}
          </p>
          <p className="text-xs text-shayek-light-700 dark:text-shayek-dark-300 mb-3 leading-relaxed">
            {t('common.disclaimer.asIs')}
          </p>
          <p className="text-xs text-shayek-light-700 dark:text-shayek-dark-300 mb-3 leading-relaxed">
            {t('common.disclaimer.accuracyLimits')}
          </p>
          <p className="text-xs text-shayek-light-700 dark:text-shayek-dark-300 mb-3 leading-relaxed">
            {t('common.disclaimer.userResponsibility')}
          </p>
          <p className="text-xs text-shayek-light-700 dark:text-shayek-dark-300 mb-3 leading-relaxed">
            {t('common.disclaimer.notAdvice')}
          </p>
          <p className="text-xs text-shayek-light-700 dark:text-shayek-dark-300 mb-3 leading-relaxed">
            {t('common.disclaimer.limitationOfLiability')}
          </p>
          <p className="text-xs text-shayek-light-600 dark:text-shayek-dark-400 italic mb-3">
            {t('common.disclaimer.closing')}
          </p>
          <p className="text-xs text-shayek-light-500 dark:text-shayek-dark-500 mt-3 pt-2 border-t border-shayek-light-200 dark:border-shayek-dark-200">
            {t('common.aiDisclaimer', 'AI analysis is for guidance only. Verify important claims with trusted sources.')}
          </p>
        </div>
      )}
    </div>
  );
};

export default DisclaimerFooter;
